<template>
  <v-app style="background-color: #FBEFDA;">
    <Navigation/>
    <v-main>
      <router-view/>
    </v-main>
    <div>
      <h1 style="font-size: 12px;opacity: 0.7;margin-bottom:-2px;margin-top: 3px;">
        Părerea ta contează pentru noi. Scrie-ne la adresa: <strong>smarthoneybee@testemate.ro</strong>
      </h1>
      <h2 style="font-size: 10px;opacity: 0.7;font-style: oblique;">
        &copy; 2020 SmartHoneyBee by Ionescu Sorana &#10074; Powered by Popescu Andreea & Bucur Adrian-Cătălin
      </h2>
    </div>
  </v-app>
</template>

<script>
import Navigation from '@/components/Navigation'
export default{
  components: {
    Navigation
  }
}
</script>
